// Ensure stable object key ordering for consistent diffs
export const sortKeysDeep = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map((item) => sortKeysDeep(item)) as T;
  }
  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    const sorted: Record<string, unknown> = {};
    Object.keys(record)
      .sort((a, b) => a.localeCompare(b))
      .forEach((key) => {
        sorted[key] = sortKeysDeep(record[key]);
      });
    return sorted as unknown as T;
  }
  return value;
};
